import { render } from "./ٍSlider.vue?vue&type=template&id=4abd18f8"
import script from "./ٍSlider.vue?vue&type=script&lang=js"
export * from "./ٍSlider.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__